import getProfilePhotoStoragePath from "utils/firebase/storage-paths/getProfilePhotoStoragePath";
import uploadFile from "utils/firebase/uploadFile";

/**
 * Uploads profile photo to Firebase storage.
 *
 * @param userId the user to upload for.
 * @param file the file to upload.
 * @return the download URL
 */
export default async function uploadProfilePhoto(
  userId: string,
  file: File
): Promise<string> {
  const path = getProfilePhotoStoragePath(userId);

  return uploadFile(file, path);
}
